import axios from "axios";
import React, { useContext, useState } from "react";
import { Store } from "../Store";

const PrintReceipt = () => {
  const [receiptText, setReceiptText] = useState("");

  const { state } = useContext(Store);
  const { userInfo } = state;

  const handlePrint = async () => {
    try {
      const response = await axios.post(
        "/api/printer/print-adisyon",
        {
          text: receiptText,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        }
      );

      if (response.status === 200) {
        alert("Printed successfully!");
      } else {
        alert("Failed to print.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred.");
    }
  };

  return (
    <div>
      <h1>Print Receipt</h1>
      <textarea
        rows="10"
        cols="30"
        placeholder="Enter receipt text here"
        value={receiptText}
        onChange={(e) => setReceiptText(e.target.value)}
      />
      <br />
      <button onClick={handlePrint}>Print</button>
    </div>
  );
};

export default PrintReceipt;
